import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle cx="8" cy="8" r="6" fill="white" fill-opacity="0.1"/>
	<path d="M5 8H11M8 5V11" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`)